import { render, staticRenderFns } from "./export-limit.vue?vue&type=template&id=2b9c0384&"
import script from "./export-limit.vue?vue&type=script&lang=js&"
export * from "./export-limit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports